import React from "react"
import {formatISO} from "date-fns";

import MDBox from "materialDashboard/components/MDBox";
import Card from "@mui/material/Card";

import {useIncidentRegistryQuery, useIncidentSettingsQuery} from "./query";
import Page from "../../Page";
import {getSeasonFromDate} from "../../../utils/date";
import useDataTableFilters from "../../../components/DataTable/useDataTableFilters";
import IncidentMap from "../../Incidents/IncidentMap";
import Container from "@mui/material/Container";
import TableDataLoader from "./IncidentTable/TableDataLoader";
import useIncidentMap from "../../Incidents/useIncidentMap";
import Box from "@mui/material/Box";
import IncidentFeatureChip from "../../../components/maps/incidentFeature/IncidentFeatureChip";
import LoadingOverlay from "../../../components/LoadingOverlay";

import {ExpandButtonIcon, useExpandButtonIcon} from "../../../components/maps/ExpandButtonIcon";


const Incidents = () => {
    const incidentRegistry = useIncidentRegistryQuery();
    const incidentSettings = useIncidentSettingsQuery();

    // data states
    const currentSeason = getSeasonFromDate(new Date());
    const seasonStartISO = formatISO(currentSeason.from);
    const seasonEndISO = formatISO(currentSeason.to);

    const filterProps = {
        initialValues: {
            dateGte: seasonStartISO,
            dateLte: seasonEndISO,
        }
    };
    const initialFiltersValue = {
        date__gte: seasonStartISO,
        date__lte: seasonEndISO,
    }

    const filterState = useDataTableFilters({initialFiltersValue});

    // Map state
    const map = useIncidentMap({incidentsFilters: filterState.filters});
    const expandButtonState = useExpandButtonIcon();

    if (incidentRegistry.isLoading || incidentSettings.isLoading) {
        return <LoadingOverlay />
    }

    return <Page>
        <Container maxWidth="xxl" px={2}>
            <Box justifyContent="end" alignItems="center" display="flex" flexWrap="wrap" gap={2} my={1}>
                <ExpandButtonIcon {...expandButtonState} />
            </Box>
            <MDBox ref={map.mapBoxRef}
                   borderRadius="xl"
                   bgColor="grey-300"
                   sx={{
                       height: expandButtonState.mapHeight,
                       scrollMarginTop: 100,
                       overflow: "hidden",
                       boxShadow: 1,
                       position: "relative",
                       zIndex: 2
                   }}>
                <IncidentMap mapRef={map.mapRef}
                             incidentsGeoJSON={map.geoJSON}
                             incidentRegistry={incidentRegistry}
                             incidentSettings={incidentSettings}
                             getSelectedFeatures={map.getSelectedFeatures}
                             onFeatureClick={map.handleFeatureClick}/>
            </MDBox>
            <Card sx={{pt: 3, mt: -3, zIndex: 1}}>
                {
                    map.selectedFeatures.length > 0 && <Box sx={{display: "flex", flexWrap: "wrap", gap: 1, pt: 3, px: 3}}>
                        {
                            map.selectedFeatures.map(f =>
                                <IncidentFeatureChip key={f.properties.id}
                                                     feature={f}
                                                     onDelete={() => map.toggleFeature(f)}/>
                            )
                        }
                    </Box>
                }
                <TableDataLoader filterState={filterState}
                                 filterProps={filterProps}
                                 incidentRegistry={incidentRegistry}
                                 incidentSettings={incidentSettings}
                                 dataTableId="incidentsPublic"
                                 map={map}/>
            </Card>
        </Container>
    </Page>
}


export default Incidents;